import React from "react";
import { toFixed } from "../CustomComponent";
import HintIcon from "./HintIcon";
import { formatNumberInput, formBlockStyle, parseNumberInput, RD_GREEN_DARK, RD_GREEN_SOFT } from "./constants";

// ขั้นตอนที่ 3: ค่าลดหย่อน จัดกลุ่มที่ 1-6 ตามแบบ ภ.ง.ด.90/91
// กรอกยอดที่จ่ายจริงได้เลย ระบบจะตัดเพดานสิทธิให้เองตอนคำนวณ (คอลัมน์ "ใช้สิทธิ์ได้")
export default function StepDeduction({ catalog, values, setValue, autoMap, allowedMap, personalAllowance }) {
  const groups = catalog?.rd_deduction_groups || [];
  const typeMap = (catalog?.deduction_types || []).reduce((acc, type) => ({ ...acc, [type.value]: type }), {});

  return (
    <div className="p-3 p-md-4" style={formBlockStyle}>
      <div className="row g-2 pb-2 mb-3 border-bottom">
        <div className="col-12 col-lg-6" />
        <div className="col-6 col-lg-3 text-lg-end small text-secondary">ที่จ่ายจริง</div>
        <div className="col-6 col-lg-3 text-lg-end small text-secondary">ใช้สิทธิ์ได้</div>
      </div>

      {groups.map((group, groupIndex) => (
        <div className="mb-4" key={group.key}>
          <div className="fw-semibold mb-2" style={{ color: RD_GREEN_DARK }}>{group.label}</div>
          {group.note ? (
            <div className="rounded-3 p-3 mb-3 small" style={{ background: RD_GREEN_SOFT, color: "#12314d" }}>
              <i className="fa-solid fa-bullhorn me-2" style={{ color: RD_GREEN_DARK }} />{group.note}
            </div>
          ) : null}

          {groupIndex === 0 && (
            <div className="row g-2 align-items-center py-2 border-bottom">
              <div className="col-12 col-lg-6">ลดหย่อนผู้มีเงินได้</div>
              <div className="col-6 col-lg-3 text-lg-end text-secondary small">ระบบให้อัตโนมัติ</div>
              <div className="col-6 col-lg-3 text-lg-end fw-semibold">{toFixed(personalAllowance)}</div>
            </div>
          )}

          {group.categories.map((category) => {
            const type = typeMap[category];
            if (!type) return null;
            const auto = autoMap[category];
            const allowed = allowedMap[category];

            return (
              <div className="row g-2 align-items-center py-2 border-bottom" key={category}>
                <div className="col-12 col-lg-6">
                  <span>{type.label}</span>
                  <HintIcon text={type.hint} />
                  {auto > 0 ? (
                    <div className="small text-secondary">ระบบดึงจากสลิปเงินเดือนให้แล้ว {toFixed(auto)} บาท</div>
                  ) : null}
                </div>
                <div className="col-6 col-lg-3 text-lg-end">
                  {/* ใช้ช่องข้อความแทน type="number" เพื่อโชว์คั่นหลักพัน (1,000) ค่าที่เก็บยังเป็นตัวเลขล้วน */}
                  <input
                    type="text"
                    inputMode="decimal"
                    className="form-control ms-lg-auto"
                    style={{ maxWidth: 180, borderRadius: 8, textAlign: "right" }}
                    placeholder="0"
                    value={formatNumberInput(values[category])}
                    onChange={(event) => setValue(category, parseNumberInput(event.target.value))}
                  />
                </div>
                <div className="col-6 col-lg-3 text-lg-end fw-semibold" style={{ color: "#7a5ad6" }}>
                  {allowed === undefined ? "-" : toFixed(allowed)}
                </div>
              </div>
            );
          })}
        </div>
      ))}

      <div className="small text-secondary">
        ช่อง "ใช้สิทธิ์ได้" คือยอดที่ระบบนำไปคำนวณจริงหลังตัดเพดานตามกฎหมาย ระบบบันทึกและอัปเดตให้เองเมื่อหยุดพิมพ์
      </div>
    </div>
  );
}
